import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
const without = ['Diete punitive a base di insalata che non portano a nessun risultato sulla bilancia.', 'Senso di colpa costante dopo ogni pasto, temendo di peggiorare i sintomi.', 'Gonfiore addominale che rovina la tua autostima e non ti permette di indossare i tuoi vestiti preferiti.', 'Dipendenza da caffeina e zuccheri per riuscire ad arrivare a fine giornata.', 'Nebbia mentale e difficoltà di concentrazione sul lavoro o in famiglia.'];
const with_ = ['60 Ricette deliziose che riaccendono il metabolismo bruciagrassi in 15 minuti.', 'Energia costante dal mattino alla sera senza cali improvvisi.', 'Ventre piatto e riduzione immediata del gonfiore grazie a ingredienti anti-infiammatori.', 'Piacere di mangiare i piatti della tradizione italiana adattati alla tua salute ormonale.', 'Libertà sociale: impara a gestire cene e aperitivi senza aver paura di "fallire".', 'Chiarezza mentale e addio alla sensazione di essere perennemente stanca.'];
export function ProblemSection() {
  return <section className="py-8 px-4 bg-white" data-id="element-162">
      <div className="max-w-3xl mx-auto" data-id="element-163">
        <h2 className="text-xl sm:text-3xl font-heading font-bold text-brand-primary text-center mb-3" data-id="element-164">
          Il vero costo di una Tiroide rallentata
        </h2>
        <p className="text-sm sm:text-base text-brand-text text-center mb-2" data-id="element-165">
          Quanto tempo e salute stai perdendo, davvero?
        </p>
        <p className="text-sm sm:text-base text-brand-text text-center mb-6" data-id="element-166">
          Vivere con l'ipotiroidismo ti toglie, in media, da 3 a 5 ore di
          energia pura ogni giorno. Oltre 1.000 ore trascorse con nebbia mentale
          e stanchezza ogni anno. Ogni anno. Per sempre.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-167">
          <div className="bg-red-50 border border-red-200 rounded-lg p-5" data-id="element-168">
            <h3 className="text-lg font-bold text-red-800 mb-4 flex items-center gap-2" data-id="element-169">
              <XIcon className="w-5 h-5" data-id="element-170" />
              SENZA Tiroide Felice
            </h3>
            <ul className="space-y-3" data-id="element-171">
              {without.map((item, i) => <li key={i} className="flex gap-2 items-start text-sm text-brand-text" data-id="element-172">
                  <XIcon className="w-4 h-4 text-red-600 shrink-0 mt-0.5" data-id="element-173" />
                  <span data-id="element-174">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="bg-green-50 border border-green-200 rounded-lg p-5" data-id="element-175">
            <h3 className="text-lg font-bold text-green-800 mb-4 flex items-center gap-2" data-id="element-176">
              <CheckIcon className="w-5 h-5" data-id="element-177" />
              CON Tiroide Felice
            </h3>
            <ul className="space-y-3" data-id="element-178">
              {with_.map((item, i) => <li key={i} className="flex gap-2 items-start text-sm text-brand-text" data-id="element-179">
                  <CheckIcon className="w-4 h-4 text-green-600 shrink-0 mt-0.5" data-id="element-180" />
                  <span data-id="element-181">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}